let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("l3Pfy")).then(() => parcelRequire('au7ul'));